module.exports = __webpack_public_path__ + "media/images/athletes/2126-b00cf8bd56f68865374fd043f377d967.png";